import * as e from "react";
import c from "../lib/IconBase.es.js";
import a from "../defs/TreeStructure.es.js";
const r = e.forwardRef((t, o) => /* @__PURE__ */ e.createElement(c, { ref: o, ...t, weights: a }));
r.displayName = "TreeStructureIcon";
const n = r;
export {
  n as TreeStructure,
  r as TreeStructureIcon
};
